<template>
  <article class="button-with-text__wrapper">
    <section class="button-with-text" v-for="item in items" v-bind:data="item" v-bind:key="item.id">
      <BaseButton variant="primary" width="full">{{item.button}}</BaseButton>
      <span>{{item.text}}</span>
    </section>
  </article>
</template>

<script>
import BaseButton from '../elements/BaseButton.vue'

export default {
  name: 'ButtonsWithText',
  components: { BaseButton },
  data() {
    return {
      items: [
        {
          button: 'Sign up for online communication',
          text:
            'Please note that registration is via the Link Asset Services website.'
        },
        {
          button: 'Register for other company alerts',
          text:
            'Receive email notifications of company announcements by registering with our email alert service.'
        }
      ]
    }
  }
}
</script>

<style lang="postcss">
.button-with-text {
  @apply w-full mb-8 mr-8;
}
.button-with-text button {
  @apply mb-6;
}
.button-with-text__wrapper {
  @apply w-full;
}
@screen md {
  .button-with-text {
    @apply flex-1 mb-16;
  }
  .button-with-text__wrapper {
    @apply flex justify-between;
  }
}
</style>
